var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMdmSection(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 88,
    height: 78,
    viewBox: "0 0 88 78",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_101_42)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M31.2224 24.5085C13.9775 24.5085 0 34.5797 0 47.0047C0 53.662 4.0538 59.6454 10.394 63.7871C9.02906 69.3214 5.96012 74.1523 1.71881 77.4429C11.6263 79.9495 18.2583 73.5078 21.7933 68.4588C24.8967 69.1563 28.0557 69.5055 31.2224 69.5009C48.4592 69.5009 62.4367 59.4298 62.4367 47.0407C62.4367 34.6516 48.4592 24.5085 31.2224 24.5085Z",
    fill: "#50BFDA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.0746 50.841C18.9866 50.841 20.5366 49.1235 20.5366 47.0048C20.5366 44.8861 18.9866 43.1686 17.0746 43.1686C15.1626 43.1686 13.6127 44.8861 13.6127 47.0048C13.6127 49.1235 15.1626 50.841 17.0746 50.841Z",
    fill: "#C9E8F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.2657 50.841C32.1777 50.841 33.7277 49.1235 33.7277 47.0048C33.7277 44.8861 32.1777 43.1686 30.2657 43.1686C28.3537 43.1686 26.8038 44.8861 26.8038 47.0048C26.8038 49.1235 28.3537 50.841 30.2657 50.841Z",
    fill: "#C9E8F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.2224 24.5085C27.2867 24.495 23.3657 25.0415 19.5555 26.1347C19.5555 26.3683 19.5555 26.5929 19.5555 26.8264C19.5555 42.342 37.0112 54.9287 58.545 54.9287C59.1936 54.9287 59.8423 54.9287 60.4828 54.9287C61.7571 52.5268 62.4288 49.791 62.4286 47.0047C62.4286 34.5797 48.4592 24.5085 31.2224 24.5085Z",
    fill: "#33B0D1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.8983 44.2107C29.643 45.7902 31.5189 47.1829 33.5007 48.3703C33.7773 47.5601 33.7983 46.67 33.5603 45.8448C33.3223 45.0197 32.8392 44.3081 32.1898 43.8259C31.5403 43.3437 30.7627 43.1193 29.9835 43.1891C29.2043 43.259 28.4694 43.6191 27.8983 44.2107V44.2107Z",
    fill: "#87BECB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.4649 50.841C45.3769 50.841 46.9268 49.1235 46.9268 47.0048C46.9268 44.8861 45.3769 43.1686 43.4649 43.1686C41.5529 43.1686 40.0029 44.8861 40.0029 47.0048C40.0029 49.1235 41.5529 50.841 43.4649 50.841Z",
    fill: "#87BECB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.225 41.2639C83.8246 37.1312 88 31.049 88 24.266C88 11.841 74.0225 1.79675 56.7533 1.79675C39.4841 1.79675 25.5633 11.841 25.5633 24.257C25.5633 36.673 39.5408 46.7173 56.7857 46.7173C59.5969 46.7213 62.4026 46.4447 65.169 45.8907C68.3553 51.0117 75.3035 59.1603 86.2488 56.3932C81.61 52.8096 78.382 47.3975 77.225 41.2639V41.2639Z",
    fill: "#C9E8F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.9136 28.6951C44.8256 28.6951 46.3756 26.9776 46.3756 24.8589C46.3756 22.7402 44.8256 21.0227 42.9136 21.0227C41.0016 21.0227 39.4517 22.7402 39.4517 24.8589C39.4517 26.9776 41.0016 28.6951 42.9136 28.6951Z",
    fill: "#87BECB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.3039 28.6951C71.2158 28.6951 72.7658 26.9776 72.7658 24.8589C72.7658 22.7402 71.2158 21.0227 69.3039 21.0227C67.3919 21.0227 65.8419 22.7402 65.8419 24.8589C65.8419 26.9776 67.3919 28.6951 69.3039 28.6951Z",
    fill: "#87BECB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.1046 28.6951C58.0166 28.6951 59.5666 26.9776 59.5666 24.8589C59.5666 22.7402 58.0166 21.0227 56.1046 21.0227C54.1927 21.0227 52.6427 22.7402 52.6427 24.8589C52.6427 26.9776 54.1927 28.6951 56.1046 28.6951Z",
    fill: "#87BECB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.87525 6.06422C5.08346 8.08564 16.3044 16.1713 18.2178 15.1471C20.1312 14.123 16.5963 11.266 16.5233 11.0234C16.4503 10.7809 9.12106 3.52172 6.87525 6.06422Z",
    fill: "#E5CE40"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.534 -4.15212e-05C16.6692 0.530021 21.4365 10.5473 23.0661 10.6821C24.6958 10.8168 23.2769 7.50169 23.3094 7.322C23.3418 7.14232 20.8852 -0.619945 18.534 -4.15212e-05Z",
    fill: "#E5CE40"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.07261 18.5432C5.04294 21.5888 13.8154 23.0981 14.991 22.1368C16.1666 21.1755 14.3748 19.5225 12.8911 18.9834C11.4074 18.4444 6.80229 16.369 6.07261 18.5432Z",
    fill: "#E5CE40"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.4387 68.9619C72.4253 70.9025 64.2528 63.248 64.569 61.4152C64.8852 59.5825 67.6418 61.9363 67.812 61.9453C67.9823 61.9543 74.7116 66.5272 73.4387 68.9619Z",
    fill: "#E5CE40"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.8609 72.3489C62.9637 73.8762 59.9558 66.8327 60.3774 65.6288C60.799 64.4249 62.3394 65.5749 63.0448 66.7069C63.7502 67.8389 66.2473 71.2619 64.8609 72.3489Z",
    fill: "#E5CE40"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_101_42"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 88,
    height: 78,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMdmSection);
export default __webpack_public_path__ + "static/media/mdm_section.8ee9d7e34e6ef17cdccb7f40c304ca9e.svg";
export { ForwardRef as ReactComponent };